var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-2 pb-3 chartLegend"},_vm._l((_vm.series),function(s){return _c('BarChartLegendItem',{key:s.name,staticClass:"mt-3 mx-2",attrs:{"color":s.color,"text":s.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }